/* eslint-disable import/prefer-default-export */
/**
 * Misc util functions that don't belong anywhere else.
 * Each util function MUST HAVE a JSDoc description on them
 */

/**
 * Return the components display name (eases debugging with high order components)
 * @param  {class} Component  [React Component]
 * @return {string}           [display name of component]
 */
export function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

/**
 * Wait till an element exists on the page to execute a callback
 * @param  {string} selector [CSS selector]
 * @param  {func} callback   [callback]
 * @return {null}
 */
export function waitTillExists(selector, callback) {
  const check = setInterval(() => {
    if (null !== document.querySelector(selector)) {
      callback();
      clearInterval(check);
    }
  }, 10);
}



// WEBPACK FOOTER //
// ./app/services/util.js